export default "__VITE_ASSET__DNWJbCcT__"